export type RuleErrorCode =
  | 'GAME_OVER'
  | 'NOT_YOUR_TURN'
  | 'UNKNOWN_PIECE'
  | 'PIECE_CAPTURED'
  | 'PINNED'
  | 'ILLEGAL_ACTION'
  | 'BAD_NOTATION'
  | 'BAD_RECORD';

/** Thrown for any rule violation. `code` is stable and safe to send to clients. */
export class RuleError extends Error {
  readonly code: RuleErrorCode;

  constructor(code: RuleErrorCode, message: string) {
    super(message);
    this.name = 'RuleError';
    this.code = code;
  }
}
